<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useDisplay } from 'vuetify';
import { useRoute, useRouter } from 'vue-router'
import RepositoryFactory from '@/repositories/RepositoryFactory'
const route = useRoute()
const router = useRouter()
const { smAndDown } = useDisplay();
const isFullWidth = ref(false);
const scrollY = ref(0); // To track the current scroll position
const topPosition = ref('21.5%'); // Initial top value
const isMobile = ref(false); // To track if the device is mobile
const LiveBannersRepo = RepositoryFactory.get('CourseVideos')
const liveClassCount = ref(0)
const isShowLiveBanner = ref(true)
const isNotOnMainPage = ref(false)
const handleScroll = () => {
  const currentScrollY = window.scrollY;

  if (!isMobile.value) {
    // Desktop behavior
    isFullWidth.value = currentScrollY > 0; // Full width when scrolled down

    if (currentScrollY === 0) {
      topPosition.value = '140px'; // Top position at the very top
    } else {
      topPosition.value = '75px'; // Top position when scrolled
    }
  } else {
    // Mobile behavior is already correct
    const currentScrollY = window.scrollY;

    if (isNotOnMainPage.value) {
      if (currentScrollY === 0) {
        topPosition.value = '15%'
      } else {
        topPosition.value = '10%'
      }
    } else {
      if (currentScrollY === 0) {
        topPosition.value = '21.5%'
      } else if (currentScrollY > scrollY.value) {
        topPosition.value = '10%'
      } else if (currentScrollY < scrollY.value) {
        topPosition.value = '17%'
      }
    }
  }

  scrollY.value = currentScrollY; // Update the last scroll position
};
const getData = async ()=>{
  try {
    const response = await LiveBannersRepo.getLiveVideosFromLegacy()
    liveClassCount.value = response.data.length
  } catch (error) {
    console.log(error.response.data)
  }
}
onMounted(() => {
  getData()
  isMobile.value = window.matchMedia('(max-width: 960px)').matches;
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  // Remove scroll listener
  window.removeEventListener('scroll', handleScroll);
});

watch(() => smAndDown.value, (newVal) => {
  isMobile.value = newVal;
});
watch(()=> route.name, (newVal) => {
  isNotOnMainPage.value = !(newVal === 'home' || newVal === 'talentedStudents')
  topPosition.value = newVal !== 'home' || newVal !== 'talentedStudents'? '15%':'21.5%'
  isShowLiveBanner.value = !(newVal === 'live_classes' || newVal === 'courses' || newVal === 'course');
})

</script>



<template>
  <div
    v-if="liveClassCount > 0 && isShowLiveBanner"
    class="w-100 d-flex justify-center live__banner"
    :class="[
    !$vuetify.display.smAndDown && isFullWidth ? 'full-width' : '',
    !$vuetify.display.smAndDown && !isFullWidth ? 'mt-6' : '',
  ]"
    :style="{
    top: !$vuetify.display.smAndDown ? topPosition : topPosition,
    width: !$vuetify.display.smAndDown && isFullWidth ? '100%' : '80%'
  }"
  >
    <v-card
      @click="router.push('live_classes')"
      color="#ebfbf3"
      :height="$vuetify.display.mobile ? '60px' : '80px'"
      :style="{
        margin: $vuetify.display.smAndDown ? '0' : isFullWidth ? '0' : '0 52px',
        borderRadius: $vuetify.display.smAndDown ? '16px' : isFullWidth ? '0' : '16px',
      }"
      :width="$vuetify.display.smAndDown ? '95%' : '100%'"
      flat
      class="content-text d-flex justify-space-between px-6"
    >
      <img
        alt="play-live"
        src="@/assets/images/main_page/live-green.gif"
        class="live-gif-desktop"
      />
      <span class="mr-3">
        همین الان {{ liveClassCount }} کلاس رایگان در حال برگزاریه!
      </span>
      <v-btn color="#006139" rounded="lg" variant="text">
        <span v-if="!$vuetify.display.smAndDown">مشاهده کلاس ها</span>
        <v-icon icon="$mdiChevronLeft"></v-icon>
      </v-btn>
    </v-card>
  </div>
</template>



<style scoped lang="scss">
.live__banner {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  transition: top 0.5s ease-in-out, width 0.5s ease-in-out, transform 0.5s ease-in-out;

  &.full-width {
    top: 75px;
    width: 100%; // Full screen width
    left: 50%; // Keep it centered
    transform: translateX(-50%); // Maintain centering
  }

  .content-text {
    padding: 16px;
    text-align: center;
    font-size: 1rem;
    line-height: 2rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: margin 0.5s ease-in-out, border-radius 0.5s ease-in-out;

    span {
      color: #058748;
    }

    .live-gif-desktop {
      width: 40px;

      @include media-breakpoint-down(md) {
        width: 25px;
      }
    }

    @media (max-width: 960px) {
      font-size: 0.8rem;
      line-height: 1.3rem;
      text-align: right;
      font-weight: 700;
      width: 100%;
    }
  }
}


</style>
